import { render, staticRenderFns } from "./SliderWrapper.vue?vue&type=template&id=0e82754d&"
import script from "./SliderWrapper.vue?vue&type=script&lang=js&"
export * from "./SliderWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SliderWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports